import React from 'react';

import Testimonial1 from '../assets/home_images/testimonials/testimonial1.jpg';
import Testimonial2 from '../assets/home_images/testimonials/testimonial2.jpg';
import Testimonial3 from '../assets/home_images/testimonials/testimonial3.jpg';
import Testimonial4 from '../assets/home_images/testimonials/testimonial4.jpg';
import Testimonial5 from '../assets/home_images/testimonials/testimonial5.jpg';
import Testimonial6 from '../assets/home_images/testimonials/testimonial6.jpg';

function TestimonialSection() {
  // Array of testimonial images with Facebook links
  const testimonials = [
    {
      image: Testimonial1,
      link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid02zogkxYg6ocy1E1FjCG5VWFaQWLb5FASGRU7abuGX1e9yXnyzjm6EKzxDpMYoTDL1l&id=61563842891479&rdid=0jj2ctlbxvEyND4d#',
    },
    {
      image: Testimonial2,
      link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0Ba3PxQesKKZfkZ86viH2fyuxsPHicsDjKFoHncBAZ43oqwgSNDkJo6Bf1P1uRgLJl&id=61563842891479&rdid=BkG9DBZ1kPacwurc#',
    },
    {
      image: Testimonial3,
      link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid027ZKBjJQyXdkzMHCmerK8RNwqiQDPQTUf47MaXZdfZwcsbAj242bNiuuwGj9cwXcpl&id=61563842891479&rdid=ViH4BK7CEeVV8jVp#',
    },
    {
      image: Testimonial4,
      link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0faDSTiiDsLW5krSLZap4ELyun28oBdPAzsrC1PKXaHyF9UdragEevAXbvo2DnNV6l&id=61563842891479&rdid=ARnrAFu4QlyFc2yo#',
    },
    {
      image: Testimonial5,
      link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0wxtWLi3FV39oLSoPsqHChRuW8BB5CxYCQLy7JDbXNVt4CjCibdSHdrh9hkLLmwb1l&id=61563842891479&rdid=RgZvvu1R1koNeomr#',
    },
    {
      image: Testimonial6,
      link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0w8BTcKRmS1ZpCDQ7G3AHuD1acgEFE8TCDbUEBGdSVuerEUZ7HAdCSK6MpPfqoSrRl&id=61563842891479&rdid=EKUoZd3uIYrfndmC#',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-12">
          {/* Eyebrow */}
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#F4900C]">
              <span className="h-px w-8 bg-[#F4900C]/40"></span>
              Testimonials
              <span className="h-px w-8 bg-[#F4900C]/40"></span>
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What People Say About <span className="text-[#F4900C]">WealthyCats</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Real stories from parents, educators, and students who have experienced our programs
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 max-w-6xl mx-auto space-y-6">
          {testimonials.map((testimonial, index) => (
            <a
              key={index}
              href={testimonial.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`group relative block break-inside-avoid rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 ${
                index % 2 === 0 ? 'hover:rotate-1' : 'hover:-rotate-1'
              }`}
            >
              <img
                src={testimonial.image}
                alt={`Testimonial ${index + 1}`}
                className="w-full h-auto group-hover:scale-[1.03] transition-transform duration-500"
                loading="lazy"
              />

              {/* Hover overlay with Facebook indicator */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-all duration-300"></div>
              <div className="absolute bottom-4 right-4 bg-black/70 text-white px-3 py-2 rounded-full text-sm flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                View on Facebook
              </div>
            </a>
          ))}
        </div>

        {/* Helper text */}
        <p className="text-center text-sm text-gray-500 mt-8">
          Click on any testimonial to view the full post on Facebook
        </p>
      </div>
    </section>
  );
}

export default TestimonialSection;
